import React from "react";
import { Routes, Route } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

// Website components
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HeroCarousel from "./components/HeroCarousel";
import LoanTabsSection from "./components/Services";
import EMICalculator from "./components/Emi";
import WhyChooseUs from "./components/Choose";
import GoldLoanPage from "./components/GoldLoanPage";
import Homeabout from "./components/Homeabout";
import ServiceGrid from "./components/ServiceGrid";
import BlogArticlePage from "./components/BlogArticlePage";

// Pages
import Career from "./pages/Career";
import AboutUs from "./pages/AboutUs";
import OurBlogs from "./pages/OurBlogs";
import AllBlogs from "./pages/AllBlogs";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsCondition from "./pages/TermsCondition";
import Contact from "./pages/Contact";
import JobModal from "./components/JobModal";
import PersonalLoan from "./pages/PersonalLoan";
import VehicleLoan from "./pages/Vehicleloan";
import BusinessLoan from "./pages/BusinessLoan";
import LoanAgainstLoan from "./pages/LoanAgainstLoan";
import GoldLoan from "./pages/GoldLoan";
import HousingLoan from "./pages/HousingLoan";
import Login from "./pages/Login";

// Admin
import AdminLayout from "./admin/AdminLayout";
import Dashboard from "./admin/Dashboard";
import Settings from "./admin/Settings";
import ProtectedRoute from "./components/ProtectedRoute";
import Leads from "./admin/Leads";
import PartnerPage from "./components/Partners";

/* ---------------- WEBSITE LAYOUT ---------------- */
function WebsiteLayout({ children }) {
  return (
    <>
      <Navbar />
      {children}
      <Footer />
    </>
  );
}

/* ---------------- HOME PAGE ---------------- */
function HomePage() {
  return (
    <>
      <HeroCarousel />
      <LoanTabsSection />
      <EMICalculator />
      <div className="row d-flex justify-content-center">
        <div className="col-10">
          <WhyChooseUs />
        </div>
      </div>
      <GoldLoanPage />
      <Homeabout />
      <ServiceGrid />
      <PartnerPage/>
    </>
  );
}

/* ---------------- APP ---------------- */
export default function App() {
  return (
    <Routes>

    {/* 🔐 LOGIN (NO NAVBAR / NO FOOTER) */}
    <Route path="/login" element={<Login />} />

    {/* 🌐 WEBSITE */}
    <Route
      path="/"
      element={
        <WebsiteLayout>
          <HomePage />
        </WebsiteLayout>
      }
    />

    <Route
      path="/careers"
      element={
        <WebsiteLayout>
          <Career />
        </WebsiteLayout>
      }
    />

    <Route
      path="/about-us"
      element={
        <WebsiteLayout>
          <AboutUs />
        </WebsiteLayout>
      }
    />

    <Route
      path="/blogs"
      element={
        <WebsiteLayout>
          <OurBlogs />
        </WebsiteLayout>
      }
    />

    <Route
      path="/blog-article-page"
      element={
        <WebsiteLayout>
          <BlogArticlePage />
        </WebsiteLayout>
      }
    />

    <Route
      path="/all-blogs"
      element={
        <WebsiteLayout>
          <AllBlogs />
        </WebsiteLayout>
      }
    />

    <Route
      path="/privacy-policy"
      element={
        <WebsiteLayout>
          <PrivacyPolicy />
        </WebsiteLayout>
      }
    />

    <Route
      path="/terms-condition"
      element={
        <WebsiteLayout>
          <TermsCondition />
        </WebsiteLayout>
      }
    />

    <Route
      path="/contact"
      element={
        <WebsiteLayout>
          <Contact />
        </WebsiteLayout>
      }
    />

    <Route
      path="/job-modal"
      element={
        <WebsiteLayout>
          <JobModal />
        </WebsiteLayout>
      }
    />

    <Route
      path="/personal-loan"
      element={
        <WebsiteLayout>
          <PersonalLoan />
        </WebsiteLayout>
      }
    />

    <Route
      path="/vehicle-loan"
      element={
        <WebsiteLayout>
          <VehicleLoan />
        </WebsiteLayout>
      }
    />

    <Route
      path="/business-loan"
      element={
        <WebsiteLayout>
          <BusinessLoan />
        </WebsiteLayout>
      }
    />

    <Route
      path="/loan-against-loan"
      element={
        <WebsiteLayout>
          <LoanAgainstLoan />
        </WebsiteLayout>
      }
    />

    <Route
      path="/gold-loan"
      element={
        <WebsiteLayout>
          <GoldLoan />
        </WebsiteLayout>
      }
    />

    <Route
      path="/housing-loan"
      element={
        <WebsiteLayout>
          <HousingLoan />
        </WebsiteLayout>
      }
    />

    {/* 🛡 ADMIN (SEPARATE LAYOUT) */}
    <Route
      path="/admin"
      element={
        <ProtectedRoute>
          <AdminLayout />
        </ProtectedRoute>
      }
    >
      <Route index element={<Dashboard />} />
      <Route path="leads" element={<Leads />} />
      <Route path="settings" element={<Settings />} />
    </Route>

  </Routes>
  );
}
